// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OilFuelFiltrationApplicationsPage from "../pages/OilFuelFiltrationApplications/OilFuelFiltrationApplications";
const __wvcRoutePaths = ["/OilFuelFiltrationApplicationsPage", "/fuel-lube-hydraulic-oil-filtration"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["3-layer-sintered-mesh", "404", "5-layer-sintered-mesh", "about", "aboutpage", "aperture-micron-rating-charts", "aperturemicronratingchartspage", "applications", "applicationspage", "astm-e2016-explained", "astm-e2016-scope-limitations", "astme2016explainedpage", "astme2016scopelimitationspage", "axial-slot-cylinders", "axialslotcylinderspage", "calculation-guides", "calculationguidespage", "capabilities", "capabilitiespage", "chemical-filtration", "chemicalfiltrationpage", "circumferential-slot-cylinders", "circumferentialslotcylinderspage", "contact", "contactpage", "corrosion-resistance-matrices", "corrosionresistancematricespage", "curved-screens", "curvedscreenspage", "custom-sintered-mesh", "custom-woven-mesh", "customsinteredmeshpage", "customwovenmeshpage", "cylindrical-screens", "cylindricalscreenspage", "datasheets", "datasheetspage", "differential-pressure-delta-p-models", "differentialpressuredeltapmodelspage", "downloads", "downloadspage", "engineering-calculations", "engineeringcalculationspage", "filter-baskets-plates", "filter-cartridges", "filter-cloth", "filter-components", "filter-components-selection-guide", "filter-discs", "filter-mesh-selection-guide", "filter-mesh-specifications", "filter-nozzles", "filter-tubes-and-cylinders", "filterbasketsandplatespage", "filtercartridgespage", "filterclothpage", "filtercomponentspage", "filtercomponentsselectionguidepage", "filtermeshselectionguidepage", "filtermeshspecificationspage", "filternozzlespage", "filtertubesandcylinderspage", "filtration-fundamentals", "filtrationfundamentalspage", "five-heddle-weave", "fiveheddleweavepage", "flat-panel-screens", "flatpanelscreenspage", "food-pharmaceutical-filtration", "food-processing-filtration", "foodandpharmaceuticalfiltrationpage", "foodprocessingfiltrationpage", "fuel-lube-hydraulic-oil-filtration", "gas-and-air-filtration", "gas-liquid-separation", "gasandairfiltrationpage", "gasliquidseparationpage", "heavy-duty-woven-mesh", "heavydutywovenmeshpage", "home", "homepage", "how-wire-mesh-aperture-is-measured", "industrial-water-filtration", "industrialwaterfiltrationpage", "iso-wire-mesh-standards", "isowiremeshstandardspage", "layerstandardsinteredmeshpage", "liquid-straining-filtration", "liquidfiltrationstrainingpage", "material-compatibility-guide", "materialcompatibilityguidepage", "materials-grades", "materials-surface-finishes", "materialsandgradespage", "materialsandsurfacefinishespage", "mesh-count-aperture", "mesh-filtration-fundamentals", "meshandfiltrationfundamentalspage", "meshcountandaperturepage", "micron-rating-filtration-accuracy", "micronandfiltrationpage", "mining-minerals-aggregates-screening", "miningmineralscreeningpage", "multi-layer-sintered-mesh", "multilayerpage", "oem-custom-mesh-engineering", "oemcustommeshengineeringpage", "oil-and-gas-separation", "oil-fuel-filtration", "oilfuelfiltrationapplicationspage", "oilfuelfiltrationpage", "oilgasseparationpage", "our-hometown", "ourhometownpage", "pharmaceutical-filtration", "pharmaceuticalfiltrationpage", "plain-dutch-weave", "plain-weave-wire-mesh", "plaindutchweavepage", "plainweavewiremeshpage", "plastic-recycling-filtration", "plasticrecyclingfiltrationpage", "polymer-filtration", "polymer-melt-filtration", "polymerfiltrationpage", "polymermeltfiltrationapplicationspage", "post", "powder-and-particle-screening", "powder-particle-screening", "powderandparticlescreeningpage", "powderparticlescreeningpage", "product-catalog", "product-selection", "productcatalogpage", "products", "productselectionpage", "productspage", "quality-supply", "qualitysupplypage", "request-a-quote", "requestaquotepage", "reverse-dutch-weave", "reversedutchweavepage", "screen-packs", "screen-pipes", "screen-tubes", "screening-and-separation-hub", "screeningandseparationhubpage", "screenpackspage", "screenpipespage", "screentubespage", "search", "sieve-bend-screens", "sievebendscreenspage", "sintered-dutch-weave-mesh", "sintered-multilayer-mesh", "sintered-wire-mesh", "sintered-wire-mesh-selection-guide", "sintereddutchweavemeshpage", "sinteredmultilayermeshpage", "sinteredwiremeshpage", "sinteredwiremeshselectionguidepage", "sitemap", "sitemappage", "slitcoilsandstampedfilterdiscspage", "solid-liquid-separation", "solidliquidseparationpage", "specialty-woven-mesh", "specialtywovenmeshpage", "specifications-standards", "specificationsstandardspage", "square-mesh", "squaremeshpage", "stainless-steel-filter-mesh-materials", "stainless-steel-grade-selection", "stainless-steel-material-verification", "stainlesssteelfiltermeshmaterialspage", "stainlesssteelgradeselectionpage", "stainlesssteelmaterialverificationpage", "standards-inspection", "standardsandinspectionpage", "technical-charts", "technical-resources", "technicalchartspage", "technicalresourcespage", "threelayersinteredmeshpage", "tools", "toolspage", "twill-dutch-weave", "twilldutchweavepage", "twilled-weave-wire-mesh", "twilledweavewiremeshpage", "wastewater-filtration", "wastewaterfiltrationpage", "water-liquid-filtration", "waterliquidfiltrationpage", "weave-types", "weavetypespage", "wedge-wire-screen", "wedge-wire-screen-selection-guide", "wedge-wire-specifications", "wedge-wire-tubes", "wedgewirescreenpage", "wedgewirescreenselectionguidepage", "wedgewirespecificationspage", "wedgewiretubespage", "wire-diameter-open-area", "wire-mesh-inspection-guide", "wire-mesh-specifications", "wirediameteropenareapage", "wiremeshaperturemeasurementpage", "wiremeshinspectionguidepage", "wiremeshspecificationspage", "woven-wire-mesh", "woven-wire-mesh-manufacturing-process", "wovenwiremeshmanufacturingprocesspage", "wovenwiremeshpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<OilFuelFiltrationApplicationsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OilFuelFiltrationApplicationsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
